import { cloneDeep, keys, difference } from 'lodash';
import * as PIXI from 'pixi.js-legacy';
window.PIXI = PIXI;
const util = require('./util.js');

const X_RATIO = 1920/16;
const Y_RATIO = 1080/9;

const gameRenderTools = {
  worldToScreen_x(x) {
    return x;
  },
  worldToScreen_y(y) {
    return y;
  }
}
const convertWidthAndHeightToWorldNoScale = function (x,y) {
  return {
    width:x / X_RATIO,
    height:y / Y_RATIO
  }
}


const gameRenderTools2 = {
  worldToScreen_x(x) {
    return x * X_RATIO;
  },
  worldToScreen_y(y) {
    return y * Y_RATIO;
  }
}

class TextSystem {
  constructor(systems) {
    this.systems = systems;
    this.textHitKeys = [];
    this.textCache = {};
    this.__textCacheLen = 0;
    this.enableCacheAsBitmap = false;
    this.textSizingCache = {}
  }

  before(dt) {
    this.textHitKeys = [];
  }

  after(dt) {
    const hitKeys = this.textHitKeys;
    if (this.__textCacheLen !== hitKeys.length) {
      const toRemove = difference(keys(this.textCache), hitKeys);
      const toRemoveLength = toRemove.length;
      for (let i = 0; i < toRemoveLength; i++) {
          const uuid = toRemove[i];
          const {text,parent} = this.textCache[uuid];
          text.destroy({texture:true,baseTexture:true});
          parent.removeChild(text);
          delete this.textCache[uuid];
          this.__textCacheLen--;

      }
    }
  }

  update(dt, ent) {
    const uuid = ent.uuid.uuid;
    let cache = this.textCache[uuid];

    if (!ent.gameText.__addComponents) {
      const slots = this.systems.findSlots(ent, ent.gameText);
      this.systems.addComponent(ent, slots);
      ent.gameText.__addComponents = true;
    }

    this.textHitKeys.push(uuid);
    let templatedText = ent.gameText.text || '';
    if (this.systems.luaVm) {
      const props = this.systems.getProperties(ent);
      if (Object.keys(props).length) { // dont bother if no props
        try {
          if (true) {
            templatedText = ent.gameText.templateFunc(props);
          } else {
            templatedText = sprintf(ent.gameText.text, props);
          }
        } catch (e) {/*console.error('tempalte error', e)*/ }

      }
    }

    if (!cache) {
      let text;
      const fontOpts = Object.assign({
          wordWrapWidth:ent.gameText.wordWrapWidth,
          align:ent.gameText.align || 'left'
        }, ent.gameText.component)

      if (!ent.gameText.bounded) {
        text = util.makeStyledText({}, templatedText, fontOpts);
      } else {
        const boundingBox = {
          left:-ent.transform.scale.x/2,
          right:ent.transform.scale.x/2,
          top:-ent.transform.scale.y/2,
          bottom:ent.transform.scale.y/2,
        };
        // TODO: this sometimes makes the text too big on my phone, no idea why
        // if we recalculate the format (not use the precalced __format
        // it works?
        if (typeof(ent.gameText.component.__format) !== 'undefined') {
          const {text: t} = util.makeFittedText({}, templatedText, ent.gameText.component.__format, boundingBox, convertWidthAndHeightToWorldNoScale, gameRenderTools2, true);
          text = t;
        } else {

          const id = ent.gameText.component.id;
          if (this.textSizingCache[id]) {
            const {text: t} = util.makeFittedText({}, templatedText, this.textSizingCache[id], boundingBox, convertWidthAndHeightToWorldNoScale, gameRenderTools2, true);
            text = t;
          } else {
            const fontOpts = cloneDeep(ent.gameText.component);
            delete fontOpts.wordWrapWidth;
            //fontOpts.wordWrapWidth = fontOpts.wordWrapWidth * util.TEXT_UPSCALE/2;
            //const l = this.systems.convertWidthAndHeightToWorld.bind(this.systems, ent);
            const {text: t, textOptions} = util.makeFittedText({}, templatedText, fontOpts, boundingBox, convertWidthAndHeightToWorldNoScale, gameRenderTools2, false);
            text = t;

            this.textSizingCache[id] = textOptions;
          }
        }
      }

      text.x = 0;
      text.y = 0;
      text.anchor.x = ent.transform.anchorx;
      text.anchor.y = ent.transform.anchory;
      
      //text.scale.x = 1/40;
      //text.scale.y = 1/40;

      this.systems.addInnerContainer(ent.uuid.uuid, ent);
      const parent = this.systems.pixiContainers[ent.uuid.uuid].inner;

      let v2 = ent.gameText.v === 2;
      if (v2) {
        if (!ent.gameText.bounded) {
          text.scale.x *= 1
          text.scale.y *= 1
        } else {
          text.scale.x *= 1 / ent.transform.scale.x / (4/util.TEXT_UPSCALE) 
          text.scale.y *= 1 / ent.transform.scale.y / (4/util.TEXT_UPSCALE)
        }
      } else {
        text.scale.x = 1
        text.scale.y = 1
      }

      let bgshape;
      if (ent.gameText.bg && templatedText.length) {
        if (!ent.gameText.__setupBg) {
          bgshape = new PIXI.Graphics();
          parent.addChild(bgshape);
          if (v2) {
            bgshape.scale.x = 1;
            bgshape.scale.y = 1;
          } else {
            bgshape.scale.x = 1/35;
            bgshape.scale.y = 1/35;
          }
          ent.gameText.__setupBg = true;
        }
      }

      const hackerz = new PIXI.Container();
      if (v2) {
        hackerz.scale.x = 1/30/ (util.TEXT_UPSCALE);
        hackerz.scale.y = 1/30/ (util.TEXT_UPSCALE);
      } else {
        hackerz.scale.x = 1/35;
        hackerz.scale.y = 1/35;
      }
      hackerz.addChild(text);
      parent.addChild(hackerz);
      parent.visible = false;

      this.textCache[uuid] = {
        text,
        parent,
        bgshape,
        hasBackground: false
      }
      this.__textCacheLen++;

      this.systems.createSceneGraphChildren(ent, ent.transform);

    }

    if (cache && cache.hasBackground && this.systems.isDirty(ent, 'scale')) {
      const {bgshape} = this.textCache[uuid];
      const textOptions = Object.assign({}, ent.gameText.component);

      if (!ent.gameText.bounded) {
        const shapeData = util.makeTextBackground(
          templatedText,
          textOptions,
          convertWidthAndHeightToWorldNoScale,
          this.systems.pixiApp);

        util.makeShape(this.themes, bgshape, shapeData, gameRenderTools);
      } else {
      }
    }
    if (cache && cache.parent.visible && ent.gameText.__setupBg) {
      ent.gameText.__setupBg = false;
      if (!ent.gameText.bounded) {
        this.textCache[uuid].hasBackground = true;
      } else {
        const {bgshape} = this.textCache[uuid];
        util.makeBoundedBackground(ent.gameText, {x:ent.transform.scale.x,y:ent.transform.scale.y}, bgshape, gameRenderTools);
      }
      this.systems.forceSetDirty(ent);
    }
    if (ent.gameText.__firstFrame >= 1) {
      ent.gameText.__firstFrame--;
    } else {
      cache.parent.visible = true;
    }

    if (cache && cache.text.text !== templatedText) {
      cache.text.text = templatedText;
      this.systems.addComponent(ent, this.systems.findSlots(ent, ent.gameText, 'change'));
    }

  }
}
export default TextSystem;
